import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import Links from "../../../../utilities/linksConfig/Links";
import MiesieczneTable from "./components/MiesieczneTable";
import moment from "moment/moment";
import BiletyService from "../biletyApi/BiletyService";
import SzukajMiesiecznychForm from "./components/SzukajMiesiecznychForm";
import EdycjaMiesiecznegoForm from "./components/EdycjaMiesiecznegoForm";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import ReactNotify from 'react-notify';
import TrasyService from "../../trasyConfig/trasy/TrasyService";


export default class BiletyMiesieczneContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bilety: [],
            bilet: null,
            pokazFormularz: false,
            params: null,
            trasy: []
        };
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.onClickZamknijFormularz = this.onClickZamknijFormularz.bind(this)
        this.onClickZapiszEdycje = this.onClickZapiszEdycje.bind(this)
        this.onChangeStatus = this.onChangeStatus.bind(this)

    }

    componentDidMount() {
        this.pobierzTrasy()
        // init
        this.pobierzBilety(
            {
                miesiac: (moment().month() + 1),
                rok: moment().year(),
            }
        )

    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {

            let arr = Array.from(response.data.content.filter(i => i.status >= 0))

            arr.sort((a, b) => {
                if (a.nazMiOd === "Rzeszów" && a.idTr < b.idTr) return -1
                else return 1
            })

            this.setState({trasy: arr})

        }.bind(this))
    }

    pobierzBilety(params) {

        let paramsurl = ''

        if (Boolean(params.miesiac)) {
            paramsurl = paramsurl + 'miesiac=' + params.miesiac
        }
        if (Boolean(params.rok)) {
            paramsurl = (paramsurl === '') ? 'rok=' + params.rok : paramsurl + '&rok=' + params.rok
        }
        if (Boolean(params.pesel)) {
            paramsurl = (paramsurl === '') ? 'pesel=' + params.pesel : paramsurl + '&pesel=' + params.pesel
        }

        if (Boolean(params.nazwisko)) {
            paramsurl = (paramsurl === '') ? 'nazwisko=' + params.nazwisko : paramsurl + '&nazwisko=' + params.nazwisko
        }

        if (Boolean(params.trasa)) {
            paramsurl = (paramsurl === '') ? 'idTr=' + params.trasa.idTr : paramsurl + '&idTr=' + params.trasa.idTr
        }

        this.setState({params: params})

        if (paramsurl !== '') {

            BiletyService.szukajBiletowMiesiecznych(paramsurl).then(function (response) {
                let bilety = Array.from(response.data, item => {
                    let platnosci = ''
                    if (Boolean(item.platnosciTransakcja)) platnosci += item.platnosciTransakcja + ' '
                    if (Boolean(item.platnoscTpay)) platnosci += item.platnoscTpay
                    return {
                        ...item,
                        infoPlatnosci: platnosci,
                        infoOdcinek: item.nazTr + ' ' + item.nazMiOd + ' ' + item.nazMiDo,
                        infoKlient: item.imieKl + ' ' + item.nazKl + ' ' + item.peselKl + ' ' + item.telefonKl + ' ' + item.emailKl
                    }
                })

                this.setState({bilety: bilety})
            }.bind(this))
        }
    }


    onClickSzukaj(miesiac, rok, pesel, nazwisko,trasa) {

        let paramsobj = {
            miesiac: miesiac,
            rok: rok,
            pesel: pesel,
            nazwisko: nazwisko,
            trasa:trasa
        }


        this.pobierzBilety(paramsobj)
    }

    onClickEdytuj(obj) {
        this.setState({pokazFormularz: true, bilet: obj})
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc bilet o kodzie: ' + obj.idBm)) {
            BiletyService.deleteBiletMiesieczny(obj.idBm).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunieto bilet', "", 3000)
                    this.pobierzBilety(this.state.params);
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania biletu', "", 3000)
                }
            }.bind(this))
        }
    }

    onClickZamknijFormularz() {
        this.setState({pokazFormularz: false, bilet: null})
    }

    onClickZapiszEdycje(bilet) {
        let obj = Object.assign(bilet, {idBm: this.state.bilet.idBm})

        BiletyService.editBiletMiesieczny(this.state.bilet.idBm, obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie edytowano bilet', "", 3000)
                this.pobierzBilety(this.state.params);
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas edycji biletu', "", 3000)
            }
            this.onClickZamknijFormularz()
        }.bind(this)).catch(err => console.log(err))
    }

    onChangeStatus(bilet, status) {
        BiletyService.edytujStatusMiesiecznego(bilet.idBm, status.value).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie edytowano status biletu', "", 3000)
                this.pobierzBilety(this.state.params);
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas edycji statusu biletu', "", 3000)
            }
        }.bind(this))
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'ZarzadzanieBiletamiContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-biletami',
                                    text: 'Zarządzanie biletami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-biletami/bilety-miesieczne', text: 'Bilety miesięczne'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <SzukajMiesiecznychForm handleClickSzukaj={this.onClickSzukaj} trasy={this.state.trasy}/>
                        </Col>
                        <Col xs={12}>
                            <TopIf isTrue={this.state.pokazFormularz}>
                                <EdycjaMiesiecznegoForm bilet={this.state.bilet}
                                                        handleClickAnuluj={this.onClickZamknijFormularz}
                                                        handleClickZapisz={this.onClickZapiszEdycje}
                                />
                            </TopIf>
                        </Col>
                        <Col sm={12}>
                            <MiesieczneTable data={this.state.bilety} handleEdytuj={this.onClickEdytuj} handleUsun={this.onClickUsun}
                                             handleChangeStatus={this.onChangeStatus}/>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyMiesieczne/BiletyMiesieczneContainer.js